import $ from 'jquery';

export default class BackToTop {

  constructor(){
  }

  init(){
    $('.back-to-top').on('click', function () {
      $("html, body").animate({
        scrollTop: 0
      },300,function(){

      });
    })
  }


}
